<template>
    <div>
        <h1 class="mt-12 text-2xl font-bold text-blue-900">Gin Member Dashboard</h1>

        <dashboard-insights :insights="insights"></dashboard-insights>

        <div class="flex flex-col mt-4">
            <h1 class="text-lg font-bold text-blue-900 mb-2 ml-1">Member Files</h1>
            <div class="-my-2 sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow border-b border-gray-200 sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                            <tr>
                                <th @click="sortBy('display_name')" :class="{'font-extrabold' : sortKey === 'display_name' }" scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    <div class="cursor-pointer flex items-center justify-between">
                                        <span>File Name</span>
                                        <span v-if="sortKey === 'display_name'">
                                                <svg :class="{'transform rotate-180' : sortOrder === 'desc' }" class="w-4 h-4 ml-1 transition duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"></path></svg>
                                            </span>
                                    </div>
                                </th>
                                <th @click="sortBy('updated_at')" :class="{'font-extrabold' : sortKey === 'updated_at' }" scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    <div class="cursor-pointer flex items-center justify-between">
                                        <span>Updated At</span>
                                        <span v-if="sortKey === 'updated_at'">
                                                <svg :class="{'transform rotate-180' : sortOrder === 'desc' }" class="w-4 h-4 ml-1 transition duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"></path></svg>
                                            </span>
                                    </div>
                                </th>

                                <th scope="col" class="relative px-6 py-3">
                                    <span class="sr-only">View</span>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, idx) in sortedMemberFiles" :class="{ 'bg-white' : idx % 2 === 0, 'bg-gray-50' : idx % 2 !== 0, 'bg-blue-50' : showMenu === item.id }">
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {{ item.display_name }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                                    {{ item.updated_at | niceTimestamp }}
                                </td>
                                <td class="px-6 py-4 align-top text-right text-sm font-medium">
                                    <a clas="font-semibold text-blue-500" :href="`/storage/${item.name }`" target="_blank" >View</a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <!--
        <h1 class="mt-12 text-2xl font-bold text-blue-900">Quick Links</h1>
        <div class="mt-3 rounded-lg bg-gray-200 overflow-hidden border border-gray-200 divide-y divide-gray-200 sm:divide-y-0 sm:grid sm:grid-cols-3 sm:gap-px">
        <a href="/storage/board-meeting-dates.pdf" target="_blank" class="rounded-tl-lg rounded-tr-lg sm:rounded-tr-none relative block group bg-white hover:bg-gray-50 p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
            <div>
                    <span class="rounded-lg inline-flex p-3 bg-teal-50 text-teal-700 ring-4 ring-white">
                      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                    </span>
            </div>
            <div class="mt-4">
                <h3 class="text-lg font-medium">
                    <div class="focus:outline-none" >
                        <span aria-hidden="true" class="absolute inset-0"></span>
                        Advisory Board Meeting Dates
                    </div>
                </h3>
            </div>
            <span aria-hidden="true" class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400">
                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"/></svg>
            </span>
        </a>

        <inertia-link :href="route('cottonseed-tickets')" class="cursor-pointer relative group bg-white hover:bg-gray-50 p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
            <div>
                    <span class="rounded-lg inline-flex p-3 bg-purple-50 text-purple-700 ring-4 ring-white">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"></path></svg>
                    </span>
            </div>
            <div class="mt-4">
                <h3 class="text-lg font-medium">
                    <p class="focus:outline-none">
                        <span aria-hidden="true" class="absolute inset-0"></span>
                        Cottonseed Tickets
                    </p>
                </h3>
            </div>
            <span aria-hidden="true" class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400">
                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"/></svg>
            </span>
        </inertia-link>

        <inertia-link :href="route('cottonseed-payments')"  class="cursor-pointer sm:rounded-tr-lg relative group bg-white hover:bg-gray-50 p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
            <div>
                <span class="rounded-lg inline-flex p-3 bg-yellow-50 text-yellow-700 ring-4 ring-white">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>
                </span>
            </div>
            <div class="mt-4">
                <h3 class="text-lg font-medium">
                    <p class="focus:outline-none">
                        <span aria-hidden="true" class="absolute inset-0"></span>
                        Contract Fulfillment
                    </p>
                </h3>

            </div>
            <span aria-hidden="true" class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400">
                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"/></svg>
            </span>
        </inertia-link>

        <inertia-link :href="route('daily-balances')" class="cursor-pointer relative group bg-white hover:bg-gray-50 p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
            <div>
                    <span class="rounded-lg inline-flex p-3 bg-light-blue-50 text-light-blue-700 ring-4 ring-white">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path></svg>
                    </span>
            </div>
            <div class="mt-4">
                <h3 class="text-lg font-medium">
                    <p class="focus:outline-none">
                        <span aria-hidden="true" class="absolute inset-0"></span>
                        Daily Balance Activity
                    </p>
                </h3>

            </div>
            <span aria-hidden="true" class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400">
                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"/></svg>
            </span>
        </inertia-link>

        <inertia-link :href="route('financials')"  class="relative group bg-white hover:bg-gray-50 p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
            <div>
                    <span class="rounded-lg inline-flex p-3 bg-lime-50 text-lime-700 ring-4 ring-white">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                    </span>
            </div>
            <div class="mt-4">
                <h3 class="text-lg font-medium">
                    <p class="focus:outline-none">
                        <span aria-hidden="true" class="absolute inset-0"></span>
                        Documents &amp; Financials
                    </p>
                </h3>

            </div>
            <span aria-hidden="true" class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400">
                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"/></svg>
            </span>
        </inertia-link>

        <inertia-link :href="route('wires')" class="relative group bg-white hover:bg-gray-50 p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
            <div>
                    <span class="rounded-lg inline-flex p-3 bg-indigo-50 text-indigo-700 ring-4 ring-white">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                    </span>
            </div>
            <div class="mt-4">
                <h3 class="text-lg font-medium">
                    <a class="focus:outline-none" href="#">
                        <span aria-hidden="true" class="absolute inset-0"></span>
                        Online Wires
                    </a>
                </h3>

            </div>
            <span aria-hidden="true" class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400">
                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"/></svg>
            </span>
        </inertia-link>

        <inertia-link :href="route('outturn-listings')" class="cursor-pointer relative group bg-white hover:bg-gray-50 p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
            <div>
                    <span class="rounded-lg inline-flex p-3 bg-rose-50 text-rose-700 ring-4 ring-white">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path></svg>
                    </span>
            </div>
            <div class="mt-4">
                <h3 class="text-lg font-medium">
                    <a class="focus:outline-none" href="#">
                        <span aria-hidden="true" class="absolute inset-0"></span>
                        Outturn Details
                    </a>
                </h3>

            </div>
            <span aria-hidden="true" class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400">
                    <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"/></svg>
                </span>
        </inertia-link>

        <inertia-link :href="route('monthly-statement')" class="cursor-pointer rounded-bl-lg rounded-br-lg sm:rounded-bl-none relative group bg-white hover:bg-gray-50 p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500">
            <div>
                    <span class="rounded-lg inline-flex p-3 bg-cyan-50 text-cyan-700 ring-4 ring-white">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 21h7a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v11m0 5l4.879-4.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242z"></path></svg>
                    </span>
            </div>
            <div class="mt-4">
                <h3 class="text-lg font-medium">
                    <a class="focus:outline-none" href="#">
                        <span aria-hidden="true" class="absolute inset-0"></span>
                        Monthly Statements
                    </a>
                </h3>

            </div>
            <span aria-hidden="true" class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400">
                    <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z"/></svg>
                </span>
        </inertia-link>
    </div>
    -->
    </div>
</template>

<script>
import DashboardInsights from '@/Components/Dashboard/DashboardInsights'
import DashboardEmailAccounts from '@/Components/Dashboard/DashboardEmailAccounts'

export default {
    components: {DashboardInsights, DashboardEmailAccounts},
    props: {
        insights: {
            type: Object,
            default: {}
        },
        emails: {
            type: Array,
        }
    },
    data() {
        return {
            sortKey: null
        }

    },
    methods: {
        sortBy(key) {
            this.sortKey = key
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
        },
        compareValues(key, order = 'asc') {
            return function innerSort(a, b) {
                if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) return 0;
                const comparison = a[key].toString().localeCompare(b[key].toString());

                return (
                    (order === 'desc') ? (comparison * -1) : comparison
                );
            };
        },
    },
    computed: {
        sortedMemberFiles() {
            if (this.insights.files.length) {
                return this.insights.files.sort(
                    this.compareValues(this.sortKey, this.sortOrder)
                )
            }
            return []
        }
    },
}
</script>
